import React, { Component } from "react";
import { Link } from "@reach/router";
import { FormattedMessage } from "react-intl";
import "./Frontpage.css";
import { appendLocale, parseLang } from "../utils";

export class Frontpage extends Component {
  render() {
    const queryLang = parseLang(this.props.location.search);

    return (
      <div className='Frontpage'>
        <span>
          <div>
            <p>
              <FormattedMessage id='frontpage.overview' />
            </p>
            <ul>
              <FormattedMessage tagName='li' id='frontpage.overview.operator' />
              <FormattedMessage tagName='li' id='frontpage.overview.refrigeration' />
              <FormattedMessage tagName='li' id='frontpage.overview.sprayTester' />
              <FormattedMessage tagName='li' id='frontpage.overview.pesticideInstructor' />
              <FormattedMessage tagName='li' id='frontpage.overview.pestControlOperator' />
              <FormattedMessage tagName='li' id='frontpage.overview.pestControlCompetency' />
              <FormattedMessage tagName='li' id='frontpage.overview.nameStamp' />
            </ul>
            <br />
            <FormattedMessage id='frontpage.overview.addendum' />
          </div>
          <p>
            <b>
              <FormattedMessage
                id='frontpage.householdExceptions'
                values={{
                  ytjUrl: (
                    <a href='http://www.ytj.fi' target='_blank' rel='noopener noreferrer'>
                      www.ytj.fi
                    </a>
                  ),
                }}
              />
            </b>
          </p>
        </span>
        <p>
          <Link to={appendLocale("/toiminnanharjoittajat", queryLang)} className='clearLink'>
            <FormattedMessage id='common.OperatorRegistryNavigation' />
          </Link>
          <Link to={appendLocale("/kylma-alan-patevyys", queryLang)} className='clearLink'>
            <FormattedMessage id='common.RefrigerationCompetencyRegistryNavigation' />
          </Link>
          <Link to={appendLocale("/ruiskuntestaajan-patevyys", queryLang)} className='clearLink'>
            <FormattedMessage id='common.SprayTesterCompetencyRegistryNavigation' />
          </Link>
          <Link to={appendLocale("/kasvinsuojelukoulutuksen-ja-tutkinnonjarjestajan-patevyys", queryLang)} className='clearLink'>
            <FormattedMessage id='common.PesticideInstructorTrainerRegistryNavigation' />
          </Link>
          <Link to={appendLocale("/tuholaistorjunnan-toiminnanharjoittajat", queryLang)} className='clearLink'>
            <FormattedMessage id='common.PestControlOperatorRegistryNavigation' />
          </Link>
          <Link to={appendLocale("/tuholaistorjunnan-patevyys", queryLang)} className='clearLink'>
            <FormattedMessage id='common.PestControlCompetencyRegistryNavigation' />
          </Link>
          <Link to={appendLocale("/nimileimat", queryLang)} className='clearLink'>
            <FormattedMessage id='common.NameStampRegistryNavigation' />
          </Link>
        </p>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Frontpage/Frontpage.js